module.exports = __webpack_public_path__ + "images/electricfreeway_small5bd1a5d74077600ba8b90e0000a9fa78.png";